import { useEffect, useState, useMemo } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { roundDecimal, formatCalendarDate } from "../../../../utils/helperFunctions";
import CommonLoadingIndicator from "./CommonLoadingIndicator";

type TableProps = {
  data: any[];
  columns: any[];
};

export function transformDataToRows(data: any[]) {
  const transformedData: Array<Object> = [];
  const columnNames = Object.keys(data[0]);
  data.forEach((value) => {
    let newValue: { [key: string]: any } = {};

    columnNames.forEach((columnName: string) => {
      if (columnName === "$id") {
        newValue["id"] = value[columnName];
      } else if (columnName === "consumedDate") {
        const consumedDate = value.consumedDate;
        newValue[columnName] = formatCalendarDate(consumedDate);
        newValue["rawDateTime"] = consumedDate || "";
      } else if (columnName === "userId") {
        newValue[columnName] = value[columnName];
        return;
      } else {
        newValue[columnName] = roundDecimal(
          value[columnName] === null ? 0 : value[columnName]
        );
      }
    });

    transformedData.push(newValue);
  });
  return transformedData;
}

function MicronutrientTable({ data, columns: propColumns }: TableProps) {
  const [tableRows, setTableRows] = useState<Array<Object>>();
  const [dataLoaded] = useState<Boolean>(true);

  // Relabel consumedDate column header to Date (UTC) and add sort comparator
  const columns = useMemo(
    () => propColumns.map((col: any) => {
      if (col.field === "consumedDate") {
        return {
          ...col,
          headerName: "Date (UTC)",
          sortComparator: (_v1: string, _v2: string, params1: any, params2: any) => {
            const raw1 = params1.api.getRow(params1.id)?.rawDateTime || "";
            const raw2 = params2.api.getRow(params2.id)?.rawDateTime || "";
            return raw1.localeCompare(raw2);
          },
        };
      }
      return col;
    }),
    [propColumns]
  );

  useEffect(() => {
    if (!data) return;
    if (data.length === 0) {
      setTableRows([]);
      return;
    }
    const transformedData: Array<Object> = transformDataToRows(data);
    setTableRows(transformedData);
  }, [data]);

  if (tableRows && dataLoaded) {
    return (
      <DataGrid
        rows={tableRows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        checkboxSelection
        disableRowSelectionOnClick
        pageSizeOptions={[10, 25, 50, 100]}
      />
    );
  } else {
    return <CommonLoadingIndicator />;
  }
}

export default MicronutrientTable;
